import { Faker } from '@faker-js/faker';

export const randomPhoto =
  (faker: Faker) =>
  ({ w = 640, h = 480, id = faker.datatype.number(200) } = {}) =>
    `https://placedog.net/${w}/${h}?id=${id}`;
